import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import i18next from "i18next";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import PopupWrapper from "../Common/PopupWrapper";

class DoAsk extends Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount() {
        this.initialize();
    }

    async initialize() {
        try {
            await this.props.dispatch(this.props.dataItem.reset());
            await this.props.dispatch(this.props.dataItem.initialize(this.props.rowKey, {
                withParams: true,
                newItem: true,
                refresh: false
            }));
        } catch (e) {
            console.error(e);
        }
    }

    onSave = async (e) => {
        e.preventDefault();

        await this.props.dispatch(this.props.dataItem.applyParams(this.props.dataItem_Params));
        if (!this.props.dataItem.isError) {
            if (this.props.onClose)
                this.props.onClose();
        }
    }

    onCancel = (e) => {
        e.preventDefault();

        if (this.props.onClose)
            this.props.onClose();
    }

    renderButtons = () => {
        return (<div className="modal-footer text-right">
            <div className="text-right">
                <button className="btn btn-regular -goahead ml1ex"
                        onClick={this.onSave}>{i18next.t("Send")}
                </button>
                <button className="btn btn-regular ml1ex"
                        onClick={this.onCancel}>{i18next.t("Close")}
                </button>
            </div>
        </div>)
    }

    renderParam = (h) => {
        return (
            <div className="row">
                <div className="col-md">
                    {h.ed("TextAsk")}
                </div>
            </div>
        );
    }

    render() {
        if (!this.props.dataItem.isInitialized || !this.props.dataItem_Params.isInitialized)
            return null;

        const titleField = this.props.dataItem_Params.getFieldInfo("TextAsk");
        const title = titleField.Title ? titleField.Title.replace(/\|/g, ' ') : "";
        return (
            <PopupWrapper popupVisible={true} title={title} onClose={this.props.onClose}
                          renderButtons={this.renderButtons} instructionId="11">
                <ComplexParam dataItem={this.props.dataItem_Params}
                              parentDataItem={this.props.dataItem}
                              renderParams={this.renderParam} autoFocusField="TextAsk"
                              showApplyButton={false} autoApplyParams={false}
                              afterApplyParams={this.props.onClose}
                              applyOnEnterKey={true}
                              readOnly={false} showSearchBar={false}
                              rootPath="/"/>
            </PopupWrapper>
        )
    }
}

DoAsk.propTypes = {
    dispatch: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired,
    dataItem: PropTypes.object,
    dataItem_Params: PropTypes.object,
    rowKey: PropTypes.object
}

DoAsk.defaultProps = {};

export default DoAsk